const EditableInput = ({ className, placeholder, value, onChange, isPdf, style, hidden }) => {
  if (isPdf) {
    return value ? <span style={style}>{value}</span> : ''
  } else {
    return (
      <input
        style={hidden ? { visibility: 'hidden' } : {}}
        type="text"
        className={className}
        placeholder={placeholder || ''}
        value={value || ''}
        onChange={onChange ? e => onChange(e.target.value) : undefined}
      />
    )
  }
}

export default EditableInput
